<!--this textarea version is kept for the moment, is no need, will be removed in near future-->
<div *ngIf="!isButton" class="wrapper">
    <div class="link p-2">
        {{ shareLink }}
    </div>
    <div (click)="copyLink('hidden-link')" class="copy-link">Copy link</div>
</div>
<!--new copy button feature implemented, can be triggered with isButton boolean-->
<div *ngIf="isButton" class="wrapper-button">
    <div class="share-options mt-6">
        <span class="share-link">
            <label class="font-weight-bold mb-2">{{ label }}</label>
            <div
                class="copy-link d-flex flex-row flex-nowrap justify-content-start align-items-center"
            >
                <button
                    (click)="copyLink('hidden-link')"
                    class="btn btn-primary font-weight-bold d-flex flex-row flex-wrap align-items-center"
                >
                    <i class="fa-link fa-lg fas"></i>Copy Link
                </button>
                <span *ngIf="isCopied" class="ml-4">Link copied to your clipboard</span>
            </div>
        </span>
    </div>
</div>
